<template>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>

            <v-card-title>
              <v-row>
                <v-col cols="4" md="4">
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="Search By Outturn" single-line hide-details></v-text-field>
                </v-col>
                <v-col cols="8" class="text-right">
                  <h4> {{ records[0]?.documentUpload?.fileName }}</h4>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-data-table :loading="loading" v-model="selected" :headers="computedHeaders" :items="records"
                            item-key="id" show-select class="elevation-1" :search="search" :single-select="singleSelect">
                <template v-slot:top v-if="hasCanBeApprovedData(records) && $can('CAN_INITATE_WARRANT_COLLECTION')">
                  <v-btn class="mr-2" @click="confirmAction('RECALL_SELECTED')" color="primary">Recall Selected</v-btn>
                  <v-btn class="ml-2" @click="confirmHoldAction('HOLD_SELECTED')" color="warning">Hold Selected</v-btn>
                </template>
                <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
                  <v-simple-checkbox :ripple="false" color="green" :value="isSelected"
                    @input="select($event)" v-if="!$can('CAN_INITATE_WARRANT_COLLECTION')" disabled class="d-none">
                  </v-simple-checkbox>
                  <v-simple-checkbox :ripple="false" color="green" :value="isSelected" v-else @input="select($event)">
                  </v-simple-checkbox>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" v-on="on" text icon class="actions">
                        <v-icon class="secondary--text"> more_horiz</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="showEditDialog(item)">
                        <v-list-item-title> view More</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:item.dateUpdated="{ item }">
              {{ item.dateUpdated | prettyDate }}
            </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="collectionsDetailsDialog" max-width="900px" persistent  >
        <v-card>
          <!-- Title -->
          <v-card-title class="headline font-weight-bold">
            Collection Details
            <v-spacer></v-spacer>
            <v-btn icon @click="collectionsDetailsDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-form ref="form" lazy-validation>
            <!-- Tabs -->
            <v-tabs v-model="collectionsDetailsTab" background-color="white" grow>
              <v-tab>Driver checkoffSettlementDetails</v-tab>
              <v-tab>Vehicle checkoffSettlementDetails</v-tab>
            </v-tabs>

            <v-tabs-items v-model="collectionsDetailsTab">
              <!-- Driver Details Tab -->
              <v-tab-item>
                <v-card-text>
                  <v-container>
                    <v-row
                      v-for="(d, i) in grnRecord.collectionDetailsId.collectionDrivers"
                      :key="i"
                      class="py-1"
                    >
                      <v-col cols="4" class="py-0">
                        <v-text-field
                          label="First Name"
                          :value="d.driver.firstName"
                          readonly
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="4" class="py-0">
                        <v-text-field
                          label="Last Name"
                          :value="d.driver.lastName"
                          readonly
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="4" class="py-0">
                        <v-text-field
                          label="ID Number"
                          :value="d.driver.idNumber"
                          readonly
                          outlined
                          dense
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-tab-item>

              <!-- Vehicle Details Tab -->
              <v-tab-item>
                <v-card-text>
                  <v-container>
                    <v-row
                      v-for="(d, i) in grnRecord.collectionDetailsId.collectionVehicles"
                      :key="i"
                      class="py-1"
                    >
                      <v-col cols="4" class="py-0">
                        <v-text-field
                          label="Registration Number"
                          :value="d.vehicle.registrationNumber"
                          readonly
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="4" class="py-0">
                        <v-text-field
                          label="Vehicle Type"
                          :value="d.vehicle.vehicleType"
                          readonly
                          outlined
                          dense
                        />
                      </v-col>

                      <v-col cols="4" class="py-0">
                        <v-text-field
                          label="Vehicle Description"
                          :value="d.vehicle.vehicleDescription"
                          readonly
                          outlined
                          dense
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-tab-item>
            </v-tabs-items>

            <!-- Footer -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" dark @click="collectionsDetailsDialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="confirmDialog" max-width="400">
        <v-card>
          <v-card-title class="body-2 primary--text font-weight-bold text-capitalize">Records</v-card-title>
          <v-card-text class="primary--text">
            {{ confirmMessage }}
            <v-text-field name="comment" label="Comment" v-model="approverComment" :rules="commentRules" required></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="confirmDialog = false" class="font-weight-bold">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary" class="accent--text logoutbtn" @click="approveRecords(action)">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="holdDialog" max-width="400">
  <v-card>
    <v-card-title class="body-2 primary--text font-weight-bold text-capitalize">Records</v-card-title>
    <v-card-text class="primary--text">
      {{ confirmMessage }}
      <v-text-field name="comment" label="Reason for holding" v-model="approverComment" :rules="commentRules" required></v-text-field>

      <!-- Date Picker -->
      <v-menu v-model="datePickerMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="selectedDate"
            label="Select Date"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="selectedDate" @input="datePickerMenu = false"></v-date-picker>
      </v-menu>

    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" text @click="holdDialog = false" class="font-weight-bold">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="secondary" class="accent--text logoutbtn" @click="approveRecords(action)">Confirm</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!--      <v-dialog v-model="editDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline accent&#45;&#45;text">Collection Details</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>

                <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.driverId.firstName" label="Driver firstname" readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.driverId.lastName" label="Driver lastname" readonly></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.driverId.idNumber" label="ID Number" readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.vehicleId.vehicleType" label="Vehicle Type" readonly></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.vehicleId.registrationNumber" label="Registration Number" readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.vehicleId.vehicleDescription" label="Vehicle Description" readonly></v-text-field>
                </v-col>
              </v-row>
            </v-form>

          </v-card-text>
          <v-card-actions>
            <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;" @click="editDialog = false">Close</v-btn>

          </v-card-actions>

        </v-card>
      </v-dialog>-->
    </v-container>
  </template>
<script>
import axios from 'axios'
import config from '../../../config'
import { mapState } from 'vuex'
export default {
	data () {
		return {
			selectedDate: '',
			datePickerMenu: false,
			collectionsDetailsDialog: false,
			collectionsDetailsTab: 0,
			search: '', // Define search property to bind with v-text-field
			records: [], // Ensure records is defined
			selected: [],
			loading: false,
			singleSelect: false,
			confirmDialog: false,
			holdDialog: false,
			confirmMessage: '',
			approverComment: '',
			commentRules: [(v) => !!v || 'Comment is required'],
			editDialog: false,
			action: '',
			// grnRecord: {},
			grnRecord: {
				collectionDetailsId: {
					driverId: {
						firstName: '',
						lastName: ''
					},
					vehicleId: {
						vehicleType: '',
						vehicleDescription: '',
						registrationNumber: ''
					}
				}
			},
			valid: false,
			approve: false,
			paginationOptions: {
				page: 1,
				itemsPerPage: 10
			},
			totalRecords: 0 // Total items for pagination
		}
	},
	computed: {
		computedHeaders () {
			return [

				{ text: 'OutturnNumber', value: 'outturn' },
				{ text: 'Mark', value: 'marks' },
				{ text: 'Grade', value: 'grade' },
				{ text: 'WarrantNumber', value: 'warrantNumber' },
				{ text: 'Season', value: 'season' },
				{ text: 'Sale', value: 'saleNumber' },
				{ text: 'Number Of Bags', value: 'numberOfBags' },
				{ text: 'Number Of Pockets', value: 'numberOfPocket' },
				{ text: 'Total Weight', value: 'weight' },
				{ text: 'Marketer', value: 'marketer.organisationName' },
				{ text: 'Status', value: 'status.statusName' },
				{ text: 'Date', value: 'dateUpdated' },
				{ text: 'Actions', value: 'actions' }

			]
		}
	},
	methods: {

		getDataFromApi () {
			this.loading = true
			const { page, itemsPerPage } = this.paginationOptions // Correct variable usage

			const url = `${config.serverURI}/warrant/getPendingCollection?page=${page - 1}&size=${itemsPerPage}` // Page is usually 0-based
			axios
				.get(url)
				.then((response) => {
					const data = response.data

					this.records = data.content // Ensure API returns paginated data in `content`
					this.totalRecords = data.page.totalElements // Assign total number of records, not pages

					console.log('Fetched warrants:', this.records)
				})
				.catch((error) => {
					this.message = error.response ? error.response.status : 'Error'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
				.finally(() => {
					this.loading = false
				})
		},

		handleChange () {
			// Update deleteFlag to true if the checkbox is checked
			this.grnRecord.deleteFlag = true
		},

		confirmAction (action) {
			this.action = action
			this.confirmDialog = true
			this.recordsToApprove = this.action.includes('SELECTED') ? this.selected.filter(record => record.status)
				: this.records.filter(record => record.status)
			this.confirmMessage = action + ' - ' + this.recordsToApprove.length + ' records'
		},
		confirmHoldAction (action) {
			this.action = action
			this.holdDialog = true
			this.recordsToApprove = this.action.includes('SELECTED') ? this.selected.filter(record => record.status)
				: this.records.filter(record => record.status)
			this.confirmMessage = action + ' - ' + this.recordsToApprove.length + ' records'
		},
		hasGrnStatusIdData (item) {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return item.status && (item.status.statusName === 'HOLDING_STATUS' || item.status.statusName === 'PENDING_WAREHOUSE_APPROVAL' ||
              item.status.statusName === 'PENDING_APPROVAL'
			)
			// return this.records.filter(item => item.status !== null);
		},

		hasGrnApproveWarehouseData (item) {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return item.status && (item.status.statusName === 'PENDING_WAREHOUSE_APPROVAL')
		},

		hasGrnApproveMillerData (item) {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return item.status && (item.status.statusName === 'REFERRED_TO_MILLER')
			// return this.records.filter(item => item.status !== null);
		},

		hasCanBeApprovedData (records) {
			return records.length > 0
			// && records.some(record => record.status && (record.status.statusName === 'PENDING_APPROVAL'))
		},

		hasGrnStatus () {
			// Assuming item.status is the property containing status data
			// return this.records.filter(item => item.status !== null );
			return this.records.filter(item => item.status !== null)
		},
		showEditDialog (item) {
			this.grnRecord = item
			// this.editDialog = true
			this.collectionsDetailsDialog = true
		},

		approveRecords () {
			console.log('Action:', this.action)

			if (this.recordsToApprove.length === 0) {
				this.$store.dispatch('alert/displayAlert', {
					snackbar: true,
					color: 'error',
					message: 'No record selected for action ' + this.action
				})
				return
			}

			const recordData = {
				action: this.action,
				comment: this.approverComment,
				records: this.recordsToApprove
			}

			this.loading = true // Optional: Show loading state

			axios
				.post(`${config.serverURI}/warrant/recallCollection`, recordData)
				.then((response) => {
					if (response.data.error === false) {
						this.$store.dispatch('alert/displayAlert', {
							snackbar: true,
							color: 'primary',
							message: response.data.message
						})
					} else {
						this.$store.dispatch('alert/displayAlert', {
							snackbar: true,
							color: 'error',
							message: response.data.message
						})
					}

					// this.$store.dispatch("grnfile/viewFile", this.$route.params.id);
					this.getDataFromApi()
					this.selected = []
					this.holdDialog = false
					this.confirmDialog = false
					this.recordsToApprove = []
					this.approverComment = ''
					this.confirmMessage = ''
				})
				.catch((error) => {
					this.$store.dispatch('alert/displayAlert', {
						snackbar: true,
						color: 'error',
						message: error.response?.data?.message || 'Error occurred'
					})
				})
				.finally(() => {
					this.loading = false // Optional: Hide loading state
				})
		},
		triggerEditRecord () {
			this.editRecord(this.grnRecord).then(response => {
				if (response.data.error === false) {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
				} else {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
				}
				this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
				this.selected = []
				this.editDialog = false
			}).catch(error => {
				this.$store.dispatch('alert/displayAlert', {
					snackbar: true,
					color: 'error',
					message: error.response.data ? error.response.data.message : 'Error ocurred'
				})
				this.editDialog = false
			})
		},
		triggerApproveRecord () {
			// this.millerApproveRecord(this.grnRecord).then(response => {
			this.editRecord(this.grnRecord).then(response => {
				if (response.data.error === false) {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
				} else {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
				}
				this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
				this.selected = []
				this.editDialog = false
			}).catch(error => {
				this.$store.dispatch('alert/displayAlert', {
					snackbar: true,
					color: 'error',
					message: error.response.data ? error.response.data.message : 'Error ocurred'
				})
				this.editDialog = false
			})
		}
	},
	mounted () {
		this.getDataFromApi() // Fetch data on component mount
	}
}
</script>

    <style>
    </style>
